import { render } from "./ImportaBollettiniDialog.vue?vue&type=template&id=bc0c40cc&scoped=true"
import script from "./ImportaBollettiniDialog.vue?vue&type=script&lang=js"
export * from "./ImportaBollettiniDialog.vue?vue&type=script&lang=js"

import "./ImportaBollettiniDialog.vue?vue&type=style&index=0&id=bc0c40cc&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0c40cc"]])

export default __exports__